import { languageList } from "../shared/grailConstants";
import { StringFormCombobox } from "@/components/forms/FormCombobox";

interface LanguageSelectProps {
  isErrored?: boolean;
  onChange: (...event: unknown[]) => void;
  readOnly?: boolean;
  required?: boolean;
  value?: string | null;
}

export default function LanguageSelect(props: LanguageSelectProps) {
  const { isErrored, onChange, readOnly, value, required } = props;

  return (
    <StringFormCombobox
      id="content-language-select"
      options={languageList}
      value={value}
      onChange={(next) => onChange(next)}
      readOnly={readOnly}
      required={required}
      isErrored={isErrored}
      autoComplete="new-password"
      creatable={{
        // Create only via this row (or Enter while highlighted). Blur reverts —
        // see StringFormCombobox close policy (clearOnBlur).
        formatLabel: (query) => `Other: ${query}`,
      }}
    />
  );
}
